document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelectorAll(".pdp-slideshow-item-custom").length > 0) {
      function pdp_slideshow_custom(element) {
        var autoplaySpeed = element.closest('.pdp-slideshow').getAttribute('data-autoplay-speed');
        var flickityInstance = null;
  
        function initFlickity() {
          // If instance exists, destroy it first
          if (flickityInstance) {
            flickityInstance.destroy();
          }
  
          // Determine selector based on screen width
          var cellSelector = ".pdp-slideshow-block-image-wrapper";
          if (window.matchMedia('(min-width: 750px)').matches) {
             cellSelector += ":not(.hideDesktop)";
          } else {
             cellSelector += ":not(.hideMobile)";
          }
  
          // If no elements to show, return
          if (element.querySelectorAll(cellSelector).length === 0) return;
  
          flickityInstance = new Flickity(element, {
            cellSelector: cellSelector,
            cellAlign: "center",
            contain: true,
            wrapAround: true,
            autoPlay: Number(autoplaySpeed)
          });
        }
  
        // Initial init
        initFlickity();
  
        // Listen for screen resize
        var mediaQuery = window.matchMedia('(min-width: 750px)');
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', initFlickity);
        } else if (mediaQuery.addListener) {
            mediaQuery.addListener(initFlickity);
        }
  
        var target_elem = element.parentElement;
        target_elem.querySelector(".slider-button-prev").onclick = function () {
          var prevBtn = target_elem.querySelector(".flickity-button.previous");
          if (prevBtn) prevBtn.click();
        };
  
        target_elem.querySelector(".slider-button-next").onclick = function () {
          var nextBtn = target_elem.querySelector(".flickity-button.next");
          if (nextBtn) nextBtn.click();
        };
      }
  
      document
        .querySelectorAll(".pdp-slideshow-item-custom.active-custom")
        .forEach(function (elem) {
          var flickity_elem = elem.querySelector(".pdp-slideshow-block-images");
          if (
            flickity_elem.querySelectorAll(".pdp-slideshow-block-image-wrapper")
              .length > 0
          ) {
            pdp_slideshow_custom(flickity_elem);
          }
        });
        
      // Handle tab switching if needed (replicating theme.js logic for custom class)
      // Note: theme.js handled .pdp-slideshow-tab-title clicks. 
      // If this section uses tab titles, we need to handle them here too if they target this item.
      // Based on previous analysis, this specific section might not use tabs, 
      // but if it does, the structure would be similar.
      // Since I don't see tab-title in the liquid file provided (it loops blocks and makes them all active?),
      // I assume this is a stacked view where all are active or handled differently.
      // Wait, the liquid file has `{% for block in section.blocks %}` creating `.pdp-slideshow-item active`.
      // It creates MULTIPLE items, all active?
      // Yes: `<div class="pdp-slideshow-item active" ...>` inside the loop.
      // So they are stacked vertically? 
      // If so, theme.js loop `forEach` initializes ALL of them.
      // My code above also does `forEach` so it handles multiple stacked items correctly.
    }
  });
